export default __webpack_public_path__ + "static/media/final_results.9648631d.mp3";